import React from "react";
import { connect } from "react-redux";
import "./_MemorySelectButton.scss";
import { toggleNecklaceSelectModal } from "../../redux/actions";

class MemorySelectButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  onClick = (index) => {
    if (this.state.isOpen) {
      this.setState((prevState) => ({
        isOpen: !prevState.isOpen,
      }));
      this.props.toggleNecklaceSelectModal("memory", index);
    } else {
      this.setState((prevState) => ({
        isOpen: !prevState.isOpen,
      }));
    }
  };

  desktopButtonOnClick = (index) => {
    this.props.toggleNecklaceSelectModal("memory", index);
  };

  renderDesktopButton = (number, text, disabled, memory) => {
    let buttonClass = this.state.isOpen
      ? "memory-select-button open"
      : "memory-select-button";
    if (disabled) {
      buttonClass = buttonClass + " disabled";
    }
    if (memory) {
      buttonClass = buttonClass + " active";
    }
    const buttonText = memory ? `Muisto ${number}` : text;
    return (
      <div className="memory-button-container">
        <button
          onClick={() => this.desktopButtonOnClick(number)}
          className={buttonClass}
          disabled={disabled}
        >
          <span className="title-text">{buttonText}</span>
        </button>
      </div>
    );
  };

  renderMobileButton = (number, text, rightButton, disabled, memory) => {
    let buttonClass = this.state.isOpen
      ? "memory-select-button open"
      : "memory-select-button";
    if (rightButton) {
      buttonClass = buttonClass + " right-button";
    } else {
      buttonClass = buttonClass + " left-button";
    }
    if (disabled) {
      buttonClass = buttonClass + " disabled";
    }
    if (memory) {
      buttonClass = buttonClass + " active";
    }
    const buttonText = memory ? `Muisto ${number}` : text;
    return (
      <div className="memory-button-container-mobile">
        <button
          onClick={() => this.onClick(number)}
          className={buttonClass}
          disabled={disabled}
        >
          <span className="title-text">{buttonText}</span>
          <span className="number-text">{number}</span>
        </button>
      </div>
    );
  };

  render() {
    const {
      number,
      selectMemoryButtonText,
      rightButton,
      disabled,
      memory,
    } = this.props;
    return (
      <>
        {this.renderDesktopButton(
          number,
          selectMemoryButtonText,
          disabled,
          memory
        )}
        {this.renderMobileButton(
          number,
          selectMemoryButtonText,
          rightButton,
          disabled,
          memory
        )}
      </>
    );
  }
}

const mapStateToProps = ({ configuratorPageNecklace }) => {
  const { selectMemoryButtonText } = configuratorPageNecklace;

  return {
    selectMemoryButtonText,
  };
};

export default connect(mapStateToProps, { toggleNecklaceSelectModal })(
  MemorySelectButton
);
